import FormConfig from "./formConfig.js";
import { fun_PostAction, fun_GetAction } from "@/api/index";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 表单配置
      formConfigList: FormConfig.projectInformation(),
      // 表单绑定值
      form: {
        prjName: null, // 项目名称
        publicityStartDate: null, // 公示开始时间
        publicityEndDate: null, // 公示结束时间
        publicityDay: null, // 公示天数（天）
        regulators: null, // 招标监管部门
        reserveStartTime: null, // 开标时间
        openingPlace: null, // 开标地点
        evaluationStartDate: null, // 评标时间
        reviewAdd: null, // 评标地点
        tenderReference: null, // 招标编号
        section: null, // 标段号
        tenderCorp: null, // 建设单位（招标人）
        person: null, // 经办人
        personPhone: null, // 联系电话
        agencyCorp: null, // 招标代理机构
        agencyCorpPerson: null, // 经办人
        agencyCorpPhone: null, // 联系电话
        constructionPrjName: null, // 报建项目名称
        constructionNo: null, // 报建编号
        tenderTypeName: null, // 招标方式
        tenderClassName: null, // 招标类别
        tenderContent: null, // 招标内容
        dissentDepartmentName: null, // 异议受理部门名称
        dissentDepartmentAddress: null, // 异议受理部门地址
        dissentDepartmentLinkMan: null, // 异议受理部门联系人
        dissentDepartmentLink: null, // 异议受理部门联系人手机
        dissentPostalCode: null, // 异议受理部门邮政编码
        dissentDepartmentEmail: null, // 异议受理部门电子邮箱
        supervisionDept: null, // 行政监督部门名称
        supervisionDeptAddress: null, // 行政监督部门地址
        supervisionDeptLinkMan: null, // 行政监督部门联系人
        supervisionDeptLinkPhone: null, // 行政监督部门电话
        tradingCenter: null, // 公共资源交易综合监管机构名称
        tradingCenterAddress: null, // 公共资源交易综合监管机构地址
        tradingCenterLinkMan: null, // 公共资源交易综合监管机构联系人
        tradingCenterLinkPhone: null, // 公共资源交易综合监管机构电话
        structureArea: null, // 房屋建筑工程面积
        highFloor: null, // 结构层次
        upFloor: null, // 地上
        underFloor: null, // 地下
        prjAddress: null, // 建设地址
        prjSize: null, // 建设规模
        tenderContentDescription: null, // 招标范围
        tenderScopeUpdate: null, // 招标范围修改原因
        regTenderContent: null, // 登记中的招标内容
        remarksMonomer: null, // 备注(注明单体工程名称、栋号)
        publicState: null, // 公示状态
        revocationReason: null, // 撤回原因
        modifyPublicStateName: null, // 申请变更公示状态
        isNeedPm: null, // 是否需要项目负责人/总监
        isNeedPmName: null, // 是否需要项目负责人/总监
        bulletinDuty: null, // 公示发布责任人
        performanceBondAmount: null, // 履约保证金（元）
        isProjectQualityDeposit: null, // 是否有工程质量保证金
        projectQualityDeposit: null, // 工程质量保证金（元）
        openType: null, // 公开类型
        bidOpeningAddress: null, // 开标地点
        bidOpeningTime: null, // 开标时间
        bidOpeningActor: null, // 开标参与人
        doubleOpenType: null, // 第二信封公开类型
        doubleBidOpeningAddress: null, // 第二信封开标地点
        doubleBidOpeningTime: null, // 第二信封开标时间
        doubleBidOpeningActor: null, // 第二信封开标参与人
        remarks: null, // 备注
        bidOpeningContent: null, // 开标内容
        doubleBidOpeningContent: null, // 第二信封开标内容
        tenderOpinion: null, // 招标人意见
        evaluationMethod: null, // 评标办法
        tenderBondFlag: null, // 保证金标志
        totalInvestment: null, // 批准投资总额
        isAudit: null, // 是否核验
        tenderContentNum: null, // 招标内容
        ebsflag: null, // 电子标标识
        state: null, // 状态
      },
      // 全局加载
      fullLoading: null,
      // 默认关闭弹窗
      dialogVisible: false,
      // 主键
      id: null,
      // 加载
      loading: false,
      // 表格数据
      tableData: [],
      // 中标候选人列表基础数据
      tableColumns: [
        {
          label: "中标候选人",
          prop: "corpName",
          width: "260"
        },
        {
          label: "社会信用代码",
          prop: "basicInfoCode",
          width: "240"
        },
        {
          label: "企业所有制类型",
          prop: "enterpriseTypeName",
          width: "240"
        },
        {
          label: "是否联合体投标",
          prop: "isUnionTender",
          width: "150"
        },
        {
          label: "联合投标非主体单位名称",
          prop: "tenderUnitsNotMainName",
          width: "200"
        },
        {
          label: "项目负责人",
          prop: "prjManager",
          width: "200"
        },
        {
          label: "身份证号",
          prop: "idNumber",
          width: "240"
        },
        {
          label: "证书名称",
          prop: "qualificationName",
          width: "150"
        },
        {
          label: "证书编号",
          prop: "qualificationCode",
          width: "150"
        },
        {
          label: "专业类别",
          prop: "professionalCategory",
          width: "150"
        },
        {
          label: "资格等级",
          prop: "qualificationGrade",
          width: "150"
        },
        {
          label: "中标价（万元）",
          prop: "winningPrice",
          align: "right",
          width: "150"
        },
        {
          label: "中标估算金额（万元）",
          prop: "winningEstimatedAmount",
          align: "right",
          width: "200"
        },
        {
          label: "投标报价费率",
          prop: "bidPriceText",
          width: "200"
        },
        {
          label: "中标名次",
          prop: "winningRanking",
          width: "130"
        },
        {
          label: "中标工期（日历天）",
          prop: "winningLimit",
          width: "180"
        },
        {
          label: "质量标准",
          prop: "qualityStandard",
          width: "150"
        },
        {
          label: "安全生产管理标准",
          prop: "securityManagermentStandard",
          width: "190"
        },
        {
          label: "文明施工管理标准",
          prop: "cultureManagermentStandard",
          width: "190"
        },
        {
          label: "投标文件中的资格审查资料",
          prop: "qualificationInformation",
          width: "240"
        },
        {
          label: "安全防护、文明施工及环境保护费（万元）",
          prop: "securityCivilizationFee",
          width: "330"
        },
        {
          label: "深基坑支护费（万元）",
          prop: "deepFoundationFee",
          width: "200"
        },
      ],
      // 中标公示编号
      publicityNumber: null
    }
  },

  // 注册组件
  components: {},
  // 模板编译完成
  mounted() { },

  // 自定义方法
  methods: {
    /**
     * 获取详情
     * @author shuhua
     */
    fun_Details() {
      // 发起请求
      fun_GetAction("/winningPublicity/getWinningPublicBackupDetail", {
        id: this.id
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data;
          // 判断是否需要项目负责人的值
          if (this.form.isNeedPm === "1") {
            // 赋值
            this.form.isNeedPmName = "是";
          } else {
            // 赋值
            this.form.isNeedPmName = "否";
          }
          // 内容变换
          this.fun_SetContent();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 内容变换
     * @author shuhua
     */
    fun_SetContent() {
      // 变更主键不为空并且公示状态为正常
      if (this.form.modifyId != '' && this.form.modifyId != null && this.form.publicState == '0') {
        // 是否存在申请变更公示状态
        let rtn = true;
        // 公示状态下标
        let stateNum = 0;
        // 遍历
        this.formConfigList.map((element) => {
          // 匹配公示状态
          if (element.title === "中标项目基本信息") {
            // 遍历
            element.formConfigList.map((item, index) => {
              // 匹配公示状态
              if (item.value === "publicState") {
                // 赋值
                stateNum = index;
              }
              // 匹配申请变更公示状态
              if (item.value === "modifyPublicStateName") {
                // 设置存在
                rtn = false;
              }
            });
          }
        });
        // 如果不存在
        if (rtn) {
          // 遍历
          this.formConfigList.map((element) => {
            // 匹配公示状态
            if (element.title === "中标项目基本信息") {
              // 插入撤回
              element.formConfigList.splice(stateNum + 1, 0,
                {
                  label: "申请变更公示状态：",
                  type: "input",
                  value: "modifyPublicStateName",
                  class: "redLabel",
                  disabled: true,
                  width: "100%;"
                },
                {
                  label: "撤回原因：",
                  type: "textarea",
                  value: "revocationReason",
                  class: "redLabel",
                  disabled: true,
                  width: "100%;"
                }
              );
            }
          });
        }
      } else {
        // 遍历
        this.formConfigList.map(element => {
          // 匹配公示状态
          if (element.title === "中标项目基本信息") {
            // 遍历
            element.formConfigList.map((item, index) => {
              // 匹配申请变更公示状态
              if (item.value === "modifyPublicStateName") {
                // 删除
                element.formConfigList.splice(index, 1);
              }
              // 匹配撤回原因
              if (item.value === "revocationReason") {
                // 删除
                element.formConfigList.splice(index, 1);
              }
            });
          }
        });
      }
      // 武汉市工程建设项目评定分离招标文件示范文本（适用于综合评估法）
      if (this.form.evaluationMethod === "tenderFile,gcjsxmpdfl,pdflwys" || this.form.evaluationMethod === "202204061014580094") {
        // 遍历
        this.formConfigList.map(element => {
          // 匹配中标候选人信息
          if (element.title === "中标候选人信息") {
            // 清空tip
            element.tip = "";
          }
        });
      }
      // 获取中标候选人的所有数据
      this.fun_WinningCandidateDetail();
      // 如果是否有履约保证金为无
      if (this.form.isPerformanceBondAmount == '0') {
        // 设置履约保证金为空
        this.form.performanceBondAmount = null;
      }
      // 如果是否有工程质量保证金为无
      if (this.form.isProjectQualityDeposit == '0') {
        // 设置工程质量保证金为空
        this.form.projectQualityDeposit = null;
      }
      // 公示状态为空时
      if (this.form.publicState == '' || this.form.publicState == null) {
        // 设置为正常
        this.form.publicState = '0';
      }
    },
    /**
     * 获取中标候选人的所有数据
     * @author shuhua
     */
    fun_WinningCandidateDetail() {
      // 打开加载loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/winningPublicity/getWinningCandidateBackupList", {
        publicityNumber: this.publicityNumber
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 声明变量
          let d = data;
          // 遍历
          d.map(element => {
            // 赋值
            element.corpName = element.corpName ? element.corpName.indexOf("@") > 0 ? element.corpName.substring(0, element.corpName.indexOf("@")) : element.corpName : "";
          });
          // 中标候选人信息
          this.tableData = d;
          // 关闭加载loading
          this.loading = false;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.loading = false;
        }
      });
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    },
  }
}